import ApiClient from './ApiClient';

class ChangelogApi extends ApiClient {
  constructor() {
    super('changelog', { apiVersion: 'v1' });
  }

  // QualiBot is a self-contained product and does not fetch changelog content
  // from any upstream service. Resolve to an empty feed so the changelog card
  // renders nothing and no external request is ever made.
  // eslint-disable-next-line class-methods-use-this
  fetchFromHub() {
    return Promise.resolve({ data: { posts: [] } });
  }
}

export default new ChangelogApi();
